import { FC, ReactNode } from 'react';

import HomeLayouts from './HomeLayouts';
import RootLayouts from './Rootlayouts';

interface BlogsLayoutsProps {
  children: ReactNode;
  isHomePage?: boolean;
}

const BlogsLayouts: FC<BlogsLayoutsProps> = ({ children, isHomePage = false }) => {
  const LayoutComponent = isHomePage ? HomeLayouts : RootLayouts;
  return (
    <LayoutComponent>
      <main className="mt-20 lg:mt-28">
        <section className="mx-auto my-7  w-full px-2 md:my-10 md:px-4 lg:max-w-[73.75rem] 2xl:max-w-screen-xl">
          {children}
        </section>
      </main>
    </LayoutComponent>
  );
};

export default BlogsLayouts;
